module.exports = __webpack_public_path__ + "static/media/activity-bg-2.c0063322.svg";